// extracted by mini-css-extract-plugin
export default {"imageUploadWrapper":"styles_imageUploadWrapper__gxzQy"};